module.exports = __webpack_public_path__ + "static/media/Group 1007.fda5152f.svg";